'use strict';

const ngFileUpload = require('ng-file-upload');

import { Injectable, Inject } from 'ng-metadata/core';
import {getVid, getBackendSystem} from '../../../appConfig/appConfigForward';
import {Upload} from 'ng-file-upload';

import {fileMd5Service} from 'angular-file-md5';

@Injectable()
export class UploadFileService{
    private _amazonInfo:Object;
    private _depositProfile:Object;
    private _files:Object[];
    private _fileFailed: boolean;
    private filenameToMd5Map = new Map();

	constructor(@Inject('Upload') public Upload, 
                @Inject('$q') private $q,
                @Inject('fileMd5Service') private fileMd5Service) {
    }

    get amazonInfo(){
        return this._amazonInfo;
    }

    set amazonInfo(amazonInfo){
        this._amazonInfo = amazonInfo;
    }

    get depositProfile(){
        return this._depositProfile;
    }

    set depositProfile(depositProfile){
        this._depositProfile = depositProfile;
    }
    
    get fileFailed(){
        return this._fileFailed;
    }
    
    get files(){
        return this._files;
    }

    set files(files){
        this._files = files;
    }
    
    // the file list is used later to create exceed number of file limit error message
    private exceedNoFileLimitFile(file, depositfiles) {
       let uploadedFile={
            file: file,
            fileKey: this._amazonInfo.uploadpath + file.name,
            fileName: file.name,
            type: file.type,
            label: this.getLabel(file.name),
            isUploaded: false,
            inProgress: false,
            exceedNoOfFileLimit: true,
            exceedFileSizeLimit: false,
            notAllowedFileExtension: false,
            action: "ADD",
            fileId: ""
        };

        depositfiles.push(uploadedFile);
    }
    
    private exceedFileSizeLimit(file, depositfiles) {
       let uploadedFile={
            file: file,
            fileKey: this._amazonInfo.uploadpath + file.name,
            fileName: file.name,
            type: file.type,
            label: this.getLabel(file.name),
            isUploaded: false,
            inProgress: false,
            exceedNoOfFileLimit: false,
            exceedFileSizeLimit: true,
            notAllowedFileExtension: false,
            action: "ADD",
            fileId: ""
        };

        depositfiles.push(uploadedFile);
    }
    
    private notAllowedFileExtension(file, depositfiles) {
       let uploadedFile={
            file: file,
            fileKey: this._amazonInfo.uploadpath + file.name,
            fileName: file.name,
            type: file.type,
            label: this.getLabel(file.name),
            isUploaded: false,
            inProgress: false,
            exceedNoOfFileLimit: false,
            exceedFileSizeLimit: false,
            notAllowedFileExtension: true,
            action: "ADD",
            fileId: ""
        };

        depositfiles.push(uploadedFile);
    }

    private retrieveFileUploadedSuccessCount(depositfiles){
    	var count = 0;
    	if (depositfiles == undefined || depositfiles.length == 0) {
    		return 0;
    	} else {
        	for (var i = 0; i < depositfiles.length; i++) {
	        	if ("directory" == depositfiles[i].type) {
	        		continue;
        		}
        		if (depositfiles[i].isUploaded) {
        			count++;
        		}
        	}
    	}
    	return count;
    }
    
    public uploadFiles(depositfiles){

        let files = this._files;
        this.filenameToMd5Map.clear();

        if (files && files.length) {
        
        	var noOfFiles = files.length;
        	// the default is to upload unlimited files
        	var fileCanStillUpload = files.length;
        	if (this.depositProfile.maxnooffiles != undefined && this.depositProfile.maxnooffiles != null &&
        		this.depositProfile.maxnooffiles != "NOLIMIT") {
        		// the current file limit is 1, 2, 3, 4 or 5
        		fileCanStillUpload = this.depositProfile.maxnooffiles - this.retrieveFileUploadedSuccessCount(depositfiles);
        	}
	
			if (fileCanStillUpload > 0) {
				// keep track of file processed that has no file size and extension error
				// allow much file upload as we can
				var fileProcessed = 0;
	            for (var i = 0; i < files.length; i++) {
		        	if (fileProcessed < fileCanStillUpload) {
	            
		            	// need to not count directory
		            	if ("directory" != files[i].type) {
		            		// check file size
		            		var fileSizeMB = files[i].size / 1024 / 1024;
		            		if ("NOLIMIT" != this.depositProfile.maxfilesize){
		            			var maxFileSize = parseInt(this.depositProfile.maxfilesize);
		            			if (fileSizeMB > maxFileSize) {
		            				this.exceedFileSizeLimit(files[i], depositfiles);
		            				continue;
		            			}
		            		}
		            		// check file extension
		            		var filename = files[i].name;
		            		var allowedExtension = this.depositProfile.fileextensionvalues;
		            		if (undefined !== allowedExtension && "" !== allowedExtension) {
		            			var extensions = allowedExtension.split(',');
		            			var indx = filename.lastIndexOf(".");
		            			if (indx < 0) {
		            				// no extension, disallow
		            				this.notAllowedFileExtension(files[i], depositfiles);
		            				continue;
		            			}
		            			var fileExt = filename.substr(indx + 1);
		            			var matched = false;
		            			for (var j = 0; j < extensions.length; j++) {
		            				if (fileExt.toLowerCase() == extensions[j].toLowerCase()) {
		            					matched = true;
		            					break;
		            				}
		            			}
		            			if (!matched) {
		            				// no matched extension, disallow
		            				this.notAllowedFileExtension(files[i], depositfiles);
		            				continue;
		            			}
		            		}
		            		fileProcessed++;
		            	}
	            	
		                //this.generateThumb(files[i]);
		                this.calculateMD5(files[i], depositfiles);
		        	} else {
		        		this.exceedNoFileLimitFile(files[i], depositfiles);
		            }
	            }
            } else {
	            for (var i = 0; i < files.length; i++) {
		        	this.exceedNoFileLimitFile(files[i], depositfiles);
		        }
            }
        }
    }
 
 
    private startUploadFile(file, depositfiles){
        this.uploadS3(file, depositfiles)
             .then((res)=>{
                        
              }, (reason) => {
                   console.log('Failed to upload to Amazon: ',reason);
              });
    }

    private failMD5File(file, depositfiles) {
       let uploadedFile={
            file: file,
            fileKey: this._amazonInfo.uploadpath + file.name,
            fileName: file.name,
            type: file.type,
            label: this.getLabel(file.name),
            isUploaded: false,
            inProgress: false,
            exceedNoOfFileLimit: false,
            exceedFileSizeLimit: false,
            notAllowedFileExtension: false,
            action: "ADD",
            fileId: ""
        };

        depositfiles.push(uploadedFile);
    }


    private calculateMD5(file, depositfiles) {
        // no need to handle directory
        if ("directory" == file.type) {           
           this.startUploadFile(file, depositfiles);
           return;
        }
        var curInstance = this;
        this.fileMd5Service.md5(file)
            .progress(function(stats) {
                console.log('Hashed ' + stats.loaded + ' B out of ' + stats.total + ' B');
            })
            .error(function(error) {
                console.log('Error calculating md5: %o', error);
                curInstance.failMD5File(file, depositfiles);
            }).success(function(md5sum) {
                console.log('MD5 for ' + file.name + ' is ' + md5sum);
                 curInstance.filenameToMd5Map.set(file.name, md5sum);           
                 curInstance.startUploadFile(file, depositfiles);
            });

    }

	private hexToBase64(hexstring) {
	    return btoa(hexstring.match(/\w{2}/g).map(function(a) {
	        return String.fromCharCode(parseInt(a, 16));
	    }).join(""));
	}


    private uploadS3(file, depositfiles) {        

        this._fileFailed = false;

        var fileSizeMB = file.size / 1024 / 1024;


        var fileName = file.name;
        var md5 = this.hexToBase64("\"" + this.filenameToMd5Map.get(fileName) + "\"");
        var key = this._amazonInfo.uploadpath + fileName;
        var type = file.type;
		
        //perform the upload to Amazon
        file.upload = this.Upload.upload({
            url : 'https://' + this._amazonInfo.endpoint + '/' + this._amazonInfo.bucketname + '/',
            method : 'POST',
            fields : {
                key : key,
                policy: this._amazonInfo.policy64,
                "X-Amz-Algorithm": 'AWS4-HMAC-SHA256',
                "X-Amz-Credential":this._amazonInfo.xamzcredentail,
                "X-Amz-Date": this._amazonInfo.xamzdate,
                "X-Amz-Signature": this._amazonInfo.xamzsignature, 
                
                success_action_status : '201',
                'Content-MD5' : md5,
                'Content-Type' : file.type === null || file.type === '' ? 'application/octet-stream' : file.type
                        //filename : file.name // this is needed for Flash polyfill IE8-9
            },
            file : file
        });

        var uploaded = true;

        let deferred = this.$q.defer();
        let uploadedFile={
            file: file,
            fileKey: key, 
            fileName: fileName,
            label: this.getLabel(fileName),
            type: type,
            isUploaded: uploaded,
            inProgress: true,
            exceedNoOfFileLimit: false,
            exceedFileSizeLimit: false,
            notAllowedFileExtension: false,
            action: "ADD",
            fileId: ""
        };

        depositfiles.push(uploadedFile);

        //upload succeeded
        file.upload.then((res) =>{

            var depositFile = depositfiles.filter((file)=>file.fileName ===fileName);
            depositFile[0].isUploaded=true;
            depositFile[0].inProgress=false;
            
            //return res;
            deferred.resolve(res);
        }, (reason) => {
            if (reason.status > 0) {           
                var depositFile = depositfiles.filter((file)=>file.fileName ===fileName);
                depositFile[0].isUploaded=false;
            	depositFile[0].inProgress=false;
                deferred.reject(reason);
            }
        });

        file.upload.progress(function(evt) {
            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });

      return deferred.promise;

    }

    private getLabel (fileName){
        var label= fileName;
        var index = fileName.lastIndexOf('.');
        if (index != -1)
            label= fileName.slice(0, index);

        return label;
    }

    private generateThumb (file) {
        if (file != null) {
            if ($scope.fileReaderSupported && file.type.indexOf('image') > -1) {
                $timeout(function() {
                    var fileReader = new FileReader();
                    fileReader.readAsDataURL(file);
                    fileReader.onload = function(e) {
                        $timeout(function() {
                            file.dataUrl = e.target.result;
                        });
                    };
                });
            }
        }
    }
}
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/deposit/uploadFile/uploadFile.service.ts